module.exports = __webpack_public_path__ + "static/primary-coaches-sm-mobile-6c55f0f83c4b7f8e25cc4647abb3a6df.webp";